import React from 'react'
import _get from 'lodash/get'
import { getLabel } from '../lang/index'

export const DETAIL_PAGE_STATIC_KEY = 'detailPage'
export const DETAIL_PAGE_WATCH_LABEL_CONTINUE = 'continue'
export const DETAIL_PAGE_WATCH_LABEL_FIRST = 'first'
export const DETAIL_PAGE_WATCH_LABEL_LAST = 'last'
export const DETAIL_PAGE_WATCH_LABEL_NEXT = 'next'

export const VIDEO_TAB_VALUE = 'video'
export const EPISODE_TAB_VALUE = 'episode'
export const SERIES_TAB_VALUE = 'series'
export const RELATED_TAB_VALUE = 'related'
export const GUIDE_OVERVIEW_TAB_VALUE = 'guide'
export const CURRENT_LESSON_TAB_VALUE = 'lesson'
export const EVENT_DISPLAY_TYPE = 'event'

export const PRODUCTION_STATUS_ACTIVE = 'active-production'

/**
 * User state progress item types
 */
export const USER_STATE_PROGRESS_ITEM_TYPE_VIDEO = 'VIDEO'
export const USER_STATE_PROGRESS_ITEM_TYPE_ASSET = 'ASSET'

/**
 * Course statuses
 */
export const COURSE_STATE_NOT_STARTED = 'NOT_STARTED'
export const COURSE_STATE_IN_PROGRESS = 'IN_PROGRESS'
export const COURSE_STATE_COMPLETE = 'COMPLETE'

export const getAudioLangs = (byLang) => {
  if (!byLang || !Object.keys(byLang).length) {
    return null
  }

  return Object.keys(byLang)
    .map((lang) => getLabel(lang))
    .join(', ')
}

export const getSubtitleLangs = (mediaData) => {
  if (!mediaData) {
    return null
  }

  const captions = _get(mediaData, 'captions')
  const subtitles = _get(mediaData, 'subtitles')

  return Object.keys({ ...captions, ...subtitles })
    .map((lang) => getLabel(lang))
    .join(', ')
}

export const getParagraphs = (value) => value.split(/\n\s*\n/).map((paragraph, index) => (
  <p key={index}>
    {paragraph.split(/(\n)/g).map((sentence, key) => (sentence.match(/\n/g) ? <br key={key} /> : sentence))}
  </p>
))
